import { isEqual } from '~/utils';

type RouteLike = {
	path: string;
	hash?: string;
	query?: RouteQuery;
};

type RouteQueryValue = string | null | Array<string | null>;
type RouteQuery = Record<string, RouteQueryValue | undefined>;

type SavedScrollPosition = {
	left: number;
	top: number;
};

const PAGINATION_QUERY_KEYS = new Set(['page', 'sortBy', 'orderBy']);

function isShortsRoute(path: string): boolean {
	return path === '/shorts' || path.startsWith('/shorts/');
}

function isPropertiesListingRoute(path: string): boolean {
	return (
		path === '/venda/imoveis' ||
		path.startsWith('/venda/imoveis/') ||
		path === '/aluguel/imoveis' ||
		path.startsWith('/aluguel/imoveis/')
	);
}

function getChangedQueryKeys(
	toQuery: RouteQuery = {},
	fromQuery: RouteQuery = {}
) {
	const queryKeys = new Set([
		...Object.keys(toQuery),
		...Object.keys(fromQuery)
	]);

	return Array.from(queryKeys).filter(
		key => !isEqual(toQuery[key], fromQuery[key])
	);
}

function isPaginationQueryChange(to: RouteLike, from: RouteLike): boolean {
	if (!from.path || to.path !== from.path) return false;
	if (!isPropertiesListingRoute(to.path)) return false;

	const changedQueryKeys = getChangedQueryKeys(to.query, from.query);

	return (
		changedQueryKeys.includes('page') &&
		changedQueryKeys.every(key => PAGINATION_QUERY_KEYS.has(key))
	);
}

export default {
	scrollBehavior(
		to: RouteLike,
		from: RouteLike,
		savedPosition: SavedScrollPosition | null
	) {
		if (from.path && isShortsRoute(from.path) && to.path === '/') {
			return { left: 0, top: 0 };
		}

		if (savedPosition) return savedPosition;
		if (to.hash) return { el: to.hash };
		if (isPaginationQueryChange(to, from)) return false;
		return { left: 0, top: 0 };
	}
};
